module.exports = "pegasus_template/assets/marsh-logo.png";